import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class CarteraService {

  constructor(private config: ConfigService, private http: HttpClient) { }

  getCartera(token: string, id: number, idProveedor: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cartera/" + id + "/" + idProveedor;
    return this.http.get(url, requestOptions);
  }

  getAbonosCartera(token: string, fechaIni: string, fechaFin: string, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cartera/AbonosCartera/" + fechaIni + "/" + fechaFin;
    return this.http.get(url, requestOptions);
  }

  getAbonosCarteraCajero(token: string, fechaIni: string, fechaFin: string) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cartera/AbonosCarteraCajero/" + fechaIni + "/" + fechaFin;
    return this.http.get(url, requestOptions);
  }

  getCarteraGeneral(token: string, id: number, idProveedor: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cartera/General/" + id + "/" + idProveedor;
    return this.http.get(url, requestOptions);
  }

  setCartera(token: string, data: any) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cartera";
    return this.http.post(url, data, requestOptions);
  }

  setAbono(token: string, data: any) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cartera/Abono";
    return this.http.post(url, data, requestOptions);
  }

}
